import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { observer } from "mobx-react";
import React from "react";

export default observer(({ quote, classesName }) => {
  return (
    <Table size={"small"}>
      <TableHead>
        <TableRow className={classesName}>
          <TableCell variant="head">Mat Descr</TableCell>
          <TableCell variant="head">Mat Code</TableCell>
          <TableCell variant="head">Customer Mat Code</TableCell>
          <TableCell variant="head">Customer Mat Descr</TableCell>
          <TableCell variant="head">Packing</TableCell>
          <TableCell variant="head" align="right">
            Min order Q
          </TableCell>
          <TableCell variant="head" align="right">
            Price/Ton
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {quote.Items.map((item) => (
          <Tooltip
            title={item.MaterialBlocked}
            hidden={item.MaterialBlocked === ""}
            placement="left-start"
            key={item.Materialnr + item.Quantity + item.Price}
          >
            <TableRow
              key={item.Materialnr + item.Quantity + item.Price}
              style={
                item.MaterialBlocked !== ""
                  ? { background: "red", color: "lime" }
                  : null
              }
            >
              <TableCell>{item.Materialtext}</TableCell>
              <TableCell>{item.Materialnr}</TableCell>
              <TableCell>{item.CustomerMatID}</TableCell>
              <TableCell>{item.CustomerMatText}</TableCell>
              <TableCell>
                ({item.Packagingcode}) {item.Packaging}
              </TableCell>
              <TableCell align="right">{item.Quantity}</TableCell>
              <TableCell align="right">{item.PricePerTon}</TableCell>
            </TableRow>
          </Tooltip>
        ))}
      </TableBody>
    </Table>
  );
});
